import React, { PureComponent } from 'react'
import './styles.css'
import cn from 'classnames'

export default class CoinRow extends PureComponent {

  render(){
    const { selected, coinItem, favorite, isAdmin } = this.props
    const { apiSymbol, id, name } = coinItem


    return (
      <fb className={ cn( { coinRowMain: true, selected: !!selected } ) } data-coinid={id} >

        <fb className="name">{name || apiSymbol}</fb>
        { isAdmin && <fb className="editBtn" data-editcoinid={id} >e</fb> }
        {/* <fb className='mcap'>{ mcap  && (Math.round(mcap / 1000000) + ' m')}</fb> */}
        <fb className={cn({ icon: 1, flagIcon: 1, 'icon-flag': 1, active: favorite })} data-flagcoinid={id}></fb>

      </fb>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/coinslist/coinRow/index.js